 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","pages-inbound-add-inbound-add-module":"pages-inbound-add-inbound-add-module","pages-inbound-list-inbound-list-module":"pages-inbound-list-inbound-list-module","pages-inbound-order-add-inbound-order-add-module":"pages-inbound-order-add-inbound-order-add-module","pages-inbound-order-detail-inbound-order-detail-module":"pages-inbound-order-detail-inbound-order-detail-module","pages-inbound-order-list-inbound-order-list-module":"pages-inbound-order-list-inbound-order-list-module","pages-purchase-import-purchase-import-module":"pages-purchase-import-purchase-import-module","pages-purchase-list-purchase-list-module":"pages-purchase-list-purchase-list-module","pages-purchase-order-detail-purchase-order-detail-module":"pages-purchase-order-detail-purchase-order-detail-module","pages-receiver-import-receiver-import-module":"pages-receiver-import-receiver-import-module","stock-stock-module":"stock-stock-module","default~home-home-module~pages-covid-lao-map-covid-lao-map-module~pages-covid-map-covid-map-module~t~1a521be0":"default~home-home-module~pages-covid-lao-map-covid-lao-map-module~pages-covid-map-covid-map-module~t~1a521be0","home-home-module":"home-home-module","default~pages-administrative-map-administrative-map-module~pages-covid-lao-map-covid-lao-map-module~~3cde8e40":"default~pages-administrative-map-administrative-map-module~pages-covid-lao-map-covid-lao-map-module~~3cde8e40","pages-receiver-list-receiver-list-module":"pages-receiver-list-receiver-list-module","default~pages-covid-lao-map-covid-lao-map-module~pages-covid-map-covid-map-module~pages-sku-show-lis~0a4a48f2":"default~pages-covid-lao-map-covid-lao-map-module~pages-covid-map-covid-map-module~pages-sku-show-lis~0a4a48f2","default~pages-covid-lao-map-covid-lao-map-module~pages-covid-map-covid-map-module":"default~pages-covid-lao-map-covid-lao-map-module~pages-covid-map-covid-map-module","pages-covid-lao-map-covid-lao-map-module":"pages-covid-lao-map-covid-lao-map-module","pages-covid-map-covid-map-module":"pages-covid-map-covid-map-module","pages-administrative-map-administrative-map-module":"pages-administrative-map-administrative-map-module","pages-panda-map-panda-map-module":"pages-panda-map-panda-map-module","pages-pandamap2023-pandamap2023-module":"pages-pandamap2023-pandamap2023-module","pages-receiver-map-receiver-map-module":"pages-receiver-map-receiver-map-module","pages-warehouse-map-warehouse-map-module":"pages-warehouse-map-warehouse-map-module","pages-sku-show-list-sku-show-list-module":"pages-sku-show-list-sku-show-list-module","default~pages-inbound-action-add-inbound-action-add-module~pages-inbound-action-inbound-action-module":"default~pages-inbound-action-add-inbound-action-add-module~pages-inbound-action-inbound-action-module","pages-inbound-action-add-inbound-action-add-module":"pages-inbound-action-add-inbound-action-add-module","pages-inbound-action-inbound-action-module":"pages-inbound-action-inbound-action-module","default~pages-inbound-detail-inbound-detail-module~pages-outbound-detail-outbound-detail-module~page~6ddb4411":"default~pages-inbound-detail-inbound-detail-module~pages-outbound-detail-outbound-detail-module~page~6ddb4411","pages-inbound-detail-inbound-detail-module":"pages-inbound-detail-inbound-detail-module","pages-outbound-detail-outbound-detail-module":"pages-outbound-detail-outbound-detail-module","pages-outbound-goods-detail-outbound-goods-detail-module":"pages-outbound-goods-detail-outbound-goods-detail-module","default~pages-outbound-action-add-outbound-action-add-module~pages-outbound-action-list-outbound-act~08956925":"default~pages-outbound-action-add-outbound-action-add-module~pages-outbound-action-list-outbound-act~08956925","pages-outbound-action-add-outbound-action-add-module":"pages-outbound-action-add-outbound-action-add-module","pages-outbound-action-list-outbound-action-list-module":"pages-outbound-action-list-outbound-action-list-module","pages-outbound-action-location-outbound-action-location-module":"pages-outbound-action-location-outbound-action-location-module","default~pages-sales-import-sales-import-module~pages-sales-list-sales-list-module":"default~pages-sales-import-sales-import-module~pages-sales-list-sales-list-module","pages-sales-import-sales-import-module":"pages-sales-import-sales-import-module","pages-sales-list-sales-list-module":"pages-sales-list-sales-list-module","default~pages-sales-select-action-add-sales-select-action-add-module~pages-sales-select-action-list-~125457be":"default~pages-sales-select-action-add-sales-select-action-add-module~pages-sales-select-action-list-~125457be","pages-sales-select-action-add-sales-select-action-add-module":"pages-sales-select-action-add-sales-select-action-add-module","pages-sales-select-action-list-sales-select-action-list-module":"pages-sales-select-action-list-sales-select-action-list-module","echarts":"echarts","pages-beer-beer-module":"pages-beer-beer-module","pages-chinese-chinese-module":"pages-chinese-chinese-module","pages-client-client-module":"pages-client-client-module","pages-covid-report-covid-report-module":"pages-covid-report-covid-report-module","pages-dashboard-dashboard-module":"pages-dashboard-dashboard-module","pages-help-help-module":"pages-help-help-module","pages-home1-home1-module":"pages-home1-home1-module","pages-inbound-import-inbound-import-module":"pages-inbound-import-inbound-import-module","pages-inventory-inventory-module":"pages-inventory-inventory-module","pages-language-language-module":"pages-language-language-module","pages-login-login-module":"pages-login-login-module","pages-music-music-module":"pages-music-music-module","pages-outbound-list-outbound-list-module":"pages-outbound-list-outbound-list-module","pages-outbound-order-add-outbound-order-add-module":"pages-outbound-order-add-outbound-order-add-module","pages-outbound-order-detail-outbound-order-detail-module":"pages-outbound-order-detail-outbound-order-detail-module","pages-outbound-order-list-outbound-order-list-module":"pages-outbound-order-list-outbound-order-list-module","pages-outbound-outbound-module":"pages-outbound-outbound-module","pages-outbound-truck-order-list-outbound-truck-order-list-module":"pages-outbound-truck-order-list-outbound-truck-order-list-module","pages-pinyin-pinyin-module":"pages-pinyin-pinyin-module","pages-privacy-policy-privacy-policy-module":"pages-privacy-policy-privacy-policy-module","pages-purchase-add-purchase-add-module":"pages-purchase-add-purchase-add-module","pages-purchase-order-add-purchase-order-add-module":"pages-purchase-order-add-purchase-order-add-module","pages-purchase-order-list-purchase-order-list-module":"pages-purchase-order-list-purchase-order-list-module","pages-receiver-receiver-module":"pages-receiver-receiver-module","pages-register-register-module":"pages-register-register-module","pages-sales-add-sales-add-module":"pages-sales-add-sales-add-module","pages-sales-order-add-sales-order-add-module":"pages-sales-order-add-sales-order-add-module","pages-sales-order-detail-sales-order-detail-module":"pages-sales-order-detail-sales-order-detail-module","pages-sales-order-list-sales-order-list-module":"pages-sales-order-list-sales-order-list-module","pages-supplier-supplier-module":"pages-supplier-supplier-module","pages-tabs-tabs-module":"pages-tabs-tabs-module","pages-task-tabs-task-tabs-module":"pages-task-tabs-task-tabs-module","pages-truck-order-truck-order-module":"pages-truck-order-truck-order-module","pages-truck-truck-module":"pages-truck-truck-module","pages-vinasd-vinasd-home1-vinasd-home1-module":"pages-vinasd-vinasd-home1-vinasd-home1-module","pages-warehouse-warehouse-module":"pages-warehouse-warehouse-module","polyfills-core-js":"polyfills-core-js","polyfills-css-shim":"polyfills-css-shim","polyfills-dom":"polyfills-dom","shadow-css-a3f00b33-js":"shadow-css-a3f00b33-js","swiper-bundle-44a9b1f9-js":"swiper-bundle-44a9b1f9-js","focus-visible-f4ad4f1a-js":"focus-visible-f4ad4f1a-js","input-shims-73f15161-js":"input-shims-73f15161-js","keyboard-5742b5da-js":"keyboard-5742b5da-js","status-tap-bdecfebf-js":"status-tap-bdecfebf-js","swipe-back-ee838cf8-js":"swipe-back-ee838cf8-js","tap-click-cc1ae2b2-js":"tap-click-cc1ae2b2-js","tab2-tab2-module":"tab2-tab2-module","setting-setting-module":"setting-setting-module","tab1-tab1-module":"tab1-tab1-module","tab3-tab3-module":"tab3-tab3-module"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
